<mat-card class="minimalPadding card-el mt-10 encodeQuestion">
  <p [ngClass]="{ red: (question.required| isNotCompleted: response?.answer?.[0]?.valueCoding.value: hasValidate) }">
    {{ question.text }}
  </p>
  <ng-container [ngSwitch]="question.type">
    <!-- ===== Multiple choices ===== -->

    <div *ngSwitchCase="'choice'">
      <mat-radio-group
        *ngIf="(!question?.answerDisplay || question?.answerDisplay?.type === 'radio') && question.options?.reference"
        class="radio-group"
        (change)="setChoiceInput($event.value, INPUT_TYPE.RADIO)"
      >
        <mat-radio-button
          *ngFor="let choice of choices"
          class="radio-button"
          [checked]="(response?.answer?.[0]?.valueCoding?.code === choice.code)"
          [value]="choice.code"
        >
          <span class="wrap-mat-radio-label">
            {{ choice.display }}
          </span>
        </mat-radio-button>
      </mat-radio-group>

      <div class="radio-group" *ngIf="question?.answerDisplay?.type === 'checkboxes' && question.options?.reference">
        <mat-checkbox
          class="radio-button"
          [checked]="getCheckedBox(choice.code)"
          [value]="choice.code"
          *ngFor="let choice of choices"
          (change)="onMultiChoiceInput($event.checked, $event.source.value, INPUT_TYPE.CHECKBOXES)"
        >
          <span class="wrap-mat-radio-label">
            {{ choice.display }}
          </span>
        </mat-checkbox>
      </div>

      <div *ngIf="question?.answerDisplay?.type === 'dropdown' && question.options?.reference">
        <mat-form-field *ngIf="choices?.length > 0">
          <mat-select
            (selectionChange)="setChoiceInput($event.value, INPUT_TYPE.DROPDOWN)"
            [value]="(response?.answer?.[0]?.valueCoding.code ?? question.answerDisplay?.default ?? '')"
          >
            <mat-option *ngFor="let choice of choices" [value]="choice.code">
              {{ choice.display }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- ====== Scales =====-->

      <div *ngIf="question?.answerDisplay?.type === 'range'" class="scale">
        <div *ngIf="question.answerDisplay?.displayIsShown">
          <h5
            *ngIf="question.answerDisplay?.displayIsShown && response?.answer?.[0]?.valueCoding?.code > -1 && 
            response.answer?.[0]?.valueCoding?.code < choices?.length"
          >
            {{ (response.answer?.[0]?.valueCoding?.code | valueSetChoice : choices).display }}
          </h5>
        </div>

        <div>
          <mat-icon aria-hidden="false" *ngIf="question.answerDisplay?.showMethod < 0"> sentiment_very_satisfied </mat-icon>
          <mat-icon aria-hidden="false" *ngIf="question.answerDisplay?.showMethod > 0"> mood_bad </mat-icon>
          <span *ngIf="question.answerDisplay?.showMethod === 0 && !question?.answerDisplay.scaleReverseValue">
            {{ question?.answerDisplay.min }}
          </span>
          <span *ngIf="question.answerDisplay?.showMethod === 0 && question?.answerDisplay.scaleReverseValue">
            {{ question?.answerDisplay.max }}
          </span>
          <mat-slider
            min="{{ question?.answerDisplay?.min }}"
            max="{{ question?.answerDisplay?.max }}"
            step="{{ question?.answerDisplay?.step }}"
            value="{{ question?.answerDisplay?.default }}"
            [value]="response?.answer?.[0]?.valueCoding.code"
            (valueChange)="setInput($event)"
            invert="{{ question?.answerDisplay.scaleReverseValue }}"
            thumbLabel
            tickInterval="{{ question?.answerDisplay?.step }}"
          >
          </mat-slider>
          <mat-icon aria-hidden="false" *ngIf="question.answerDisplay?.showMethod < 0"> mood_bad </mat-icon>
          <mat-icon aria-hidden="false" *ngIf="question.answerDisplay?.showMethod > 0"> sentiment_very_satisfied </mat-icon>
          <span *ngIf="question.answerDisplay?.showMethod === 0 && question?.answerDisplay.scaleReverseValue">
            {{ question?.answerDisplay.min }}
          </span>
          <span *ngIf="question.answerDisplay?.showMethod === 0 && !question?.answerDisplay.scaleReverseValue">
            {{ question?.answerDisplay.max }}
          </span>
        </div>
      </div>
    </div>

    <!-- ===== Text ===== -->

    <div *ngSwitchCase="'text'" class="mt-15">
      <div *ngIf="question?.answerDisplay?.type === 'externalLink'; else textAnswer">
        <a [href]="question.answerDisplay.default | externalUrl">{{
          question.answerDisplay.placeholder ? question.answerDisplay.placeholder : question.answerDisplay.default
        }}</a>
      </div>
      <ng-template #textAnswer>
        <form *ngIf="question?.answerDisplay?.type === 'text'; else stringAnswer">
          <mat-form-field class="input">
            <mat-label>{{ "table.answer" | translate }}</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="10"
              [value]="(response?.answer?.[0]?.valueCoding.display ?? question.answerDisplay?.default ?? '')"
              (change)="setInput($event?.target?.value)"
            ></textarea>
          </mat-form-field>
        </form>
        <ng-template #stringAnswer>
          <!-- ===== Email =====-->

          <div *ngIf="question?.answerDisplay?.type === 'email'" class="mt-15">
            <app-email-input
              label="table.answer"
              placeholder="{{ question.answerDisplay?.placeholder }}"
              [required]="question.required"
              [value]="(response?.answer?.[0]?.valueCoding.display ?? question.answerDisplay?.default ?? '')"
              (change)="setInput($event?.target.value)"
            >
            </app-email-input>
          </div>

          <!-- ===== Phone =====-->

          <div *ngIf="question?.answerDisplay?.type === 'phone'" class="mt-15">
            <app-phone-input
              label="table.answer"
              placeholder="{{ question.answerDisplay?.placeholder }}"
              [required]="question.required"
              [value]="(response?.answer?.[0]?.valueCoding.code ?? question.answerDisplay?.default ?? '')"
              (change)="setInput($event?.target.value)"
            >
            </app-phone-input>
          </div>
          <!-- ===== String =====-->
          <form *ngIf="!question?.answerDisplay?.type || question.answerDisplay.type === 'string'">
            <mat-form-field class="input">
              <mat-label>{{ "table.answer" | translate }}</mat-label>
              <input
                matInput
                [value]="(response?.answer?.[0]?.valueCoding.code ?? question.answerDisplay?.default ?? '')"
                (change)="setInput($event?.target?.value)"
              />
            </mat-form-field>
          </form>
        </ng-template>
      </ng-template>
    </div>
    <div *ngSwitchCase="'textfield'" class="mt-15">
      <form>
        <mat-form-field class="input">
          <mat-label>{{ "table.answer" | translate }}</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10"
            [value]="(response?.answer?.[0]?.valueCoding.display ?? question.answerDisplay?.default ?? '')"
            (change)="setInput($event?.target?.value)"
          ></textarea>
        </mat-form-field>
      </form>
    </div>
    <div *ngSwitchCase="'textfield-html'" class="mt-15" style="width: 100%">
      <mat-label>{{ "table.answer" | translate }}</mat-label>
      <jodit-editor
        [config]="joditConfig"
        [ngModel]="(response?.answer?.[0]?.valueCoding.display ?? question.answerDisplay?.default ?? '')"
        (change)="setInput($event?.target?.value)"
      ></jodit-editor>
    </div>

    <!-- ===== Number ===== -->

    <div *ngSwitchCase="'number'" class="mt-15">
      <!-- ===== Rating =====-->

      <div *ngIf="question?.answerDisplay?.type === 'rating'; else classicNumber" class="mt-15">
        <app-star-rating
          [value]="response?.answer?.[0]?.valueCoding.code ?? question.answerDisplay?.default ?? '0'"
          [maxRating]="question.answerDisplay?.max ?? '5'"
          [minRating]="question.answerDisplay?.min ?? '0'"
          (ratingChange)="setInput($event)"
        >
        </app-star-rating>
      </div>

      <!-- ===== Classic numbers =====-->
      <ng-template #classicNumber>
        <div *ngIf="question.answerDisplay?.multiInputs">
          <form
            style="display: flex"
            *ngFor="let qOption of question.options?.reference | valueSetChoices : questionnaire.contained; let k = index"
          >
            <mat-form-field class="input" style="max-width: 66%">
              <mat-label>{{ "table.answer" | translate }}</mat-label>
              <input
                matInput
                type="number"
                id="inputNumber_{{ index }}_{{ k }}"
                step="{{ question.answerDisplay?.step ?? (question.answerDisplay?.type === 'decimal' ? '0.01' : '1') }}"
                min="{{ question.answerDisplay?.min }}"
                max="{{ question.answerDisplay?.max }}"
                [value]="response?.answer[k * 2]?.valueCoding.code ?? question.answerDisplay?.default"
                (change)="setInput($event?.target?.value, true, k, true)"
              />
            </mat-form-field>
            {{ qOption.display }}
          </form>
        </div>
        <form style="display: flex" *ngIf="!question.answerDisplay?.multiInputs">
          <mat-form-field class="input" style="max-width: 66%">
            <mat-label>{{ "table.answer" | translate }}</mat-label>
            <input
              matInput
              type="number"
              id="inputNumber_{{ index }}"
              step="{{ question.answerDisplay?.step ?? (question.answerDisplay?.type === 'decimal' ? '0.01' : '1') }}"
              min="{{ question.answerDisplay?.min }}"
              max="{{ question.answerDisplay?.max }}"
              [value]="response?.answer[0]?.valueCoding.code ?? question.answerDisplay?.default"
              (change)="setInput($event?.target?.value, question.options?.reference !== undefined)"
            />
          </mat-form-field>
          <mat-form-field class="input" style="max-width: 33%" *ngIf="question.options?.reference">
            <mat-select
              [value]="response?.answer[1]?.valueCoding.code ?? question.answerDisplay?.default"
              (selectionChange)="setInput($event?.value, true, 1)"
            >
              <mat-option
                [value]="valueset.code"
                *ngFor="let valueset of question.options?.reference | valueSetChoices : questionnaire.contained"
              >
                {{ valueset.display }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </ng-template>
    </div>

    <!-- ===== Time =====-->

    <div *ngIf="question?.answerDisplay?.type === 'date'" class="mt-15">
      <mat-form-field class="input">
        <mat-label> {{ "table.answer" | translate }} </mat-label>
        <input
          style="max-width: 80%"
          matInput
          [value]="(response?.answer?.[0]?.valueCoding.code ?? question.answerDisplay?.default | toDate)"
          (dateChange)="setTimeInput($event.value?.toISOString(), INPUT_TYPE.DATE)"
          [matDatepicker]="picker"
          [min]="question.answerDisplay?.min"
          [max]="question.answerDisplay?.max"
        />
        <mat-hint *ngIf="question?.answerDisplay?.placeholder">{{ question.answerDisplay.placeholder }}</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </ng-container>
</mat-card>
